import ExportImage from "../../assets/images/export.svg";
import { ElemID } from "../editor/constants";
import { unhide } from "../../utils";
import { EventBus, Events } from "../eventBus";

const downloaderComponent = document.getElementById(
  ElemID.DOWNLOADER_COMPONENT,
);
const downloaderImage = document.getElementById("downloader-image");
downloaderImage.src = ExportImage; // set this up early so no flash later

const editAnotherButton = document.getElementById(
  "downloader-edit-another-button",
);

function initDownloader(payload) {
  editAnotherButton.addEventListener("click", function () {
    window.location.reload();
  });

  unhide(downloaderComponent);
  triggerDownload(payload.data, payload.filename);
}

function triggerDownload(data, filename) {
  const blob = new Blob([data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);

  const fakeLink = document.createElement("a");
  fakeLink.style.display = "none";
  fakeLink.href = url;
  fakeLink.download = filename;
  document.body.appendChild(fakeLink);

  fakeLink.click();
  window.URL.revokeObjectURL(url);
}

EventBus.subscribe(Events.EXPORT_DONE, function (payload) {
  initDownloader(payload);
});
